import React from "react";
import { Grid } from "@material-ui/core";

const MedicalNetwork = ({ children }) => {
  return (
    <Grid container>
      <Grid item xs={12}>
        {children}
      </Grid>
    </Grid>
  );
};

export default MedicalNetwork;
